import template from './steps.component.html';

class StepsController {
  constructor() {
  }
}

const StepsComponent = {
  template,
  controller: StepsController,
  bindings: {
    stepData: '<',
    stepActiveIndex: '<'
  },
}

export default StepsComponent;
